export const environment = {
  production: false,
  envName: "QA",
  appVersion: "1.3.0",
  
  //QA
  apiBaseUrl: "https://api-qa.racingplay.mx/api/"
};
